import React  from 'react';
import { connect } from "react-redux";
import axios from "axios";
import routes from "../../assets/apiRoutes.json";
import { Button } from "devextreme-react/button";
import Form from "devextreme-react/form";
import { RadioGroup } from "devextreme-react/radio-group";
import Toolbar, { Item } from "devextreme-react/toolbar";
import List from "devextreme-react/list";
import { LoadIndicator } from "devextreme-react/load-indicator";
import ArrayStore from "devextreme/data/array_store";
import { createStore } from "devextreme-aspnet-data-nojquery";
import { SelectBox } from "devextreme-react/select-box";
import { HubConnectionBuilder } from "@microsoft/signalr";
import Popup from "devextreme-react/popup";
import LookUpForm from "../../common/lookups/LookUpForm"
import ScrollView from "devextreme-react/scroll-view";
import Drawer from 'devextreme-react/drawer';
import { ABECASUSER_LOGIN_TYPE } from "../../common/permissions";
import Accordion from 'devextreme-react/accordion';
import '../../common/css/searchPage.css';

import DataGrid, {
  Column,
  Editing,
  Lookup
} from "devextreme-react/data-grid";

import { alert } from "devextreme/ui/dialog";

const dataGrid = React.createRef();
const selectBox = React.createRef();
const selectBoxMacro1 = React.createRef();
const selectBoxMacro2 = React.createRef();
const list = React.createRef();
const searchpanel = [
  {
    ID: 1,
    Name: 'Search Filters'
  }
];
const orderByData = [
  { ID: 0, Text: "None" },
  { ID: 1, Text: "Ascending" },
  { ID: 3, Text: "Descending" },
];

const orderByDataSource = new ArrayStore({
  data: orderByData,
  key: "ID",
});

const prefixData = [
  { ID: 0, Text: "And" },
  { ID: 1, Text: "Or" },
];

const prefixDataSource = new ArrayStore({
  data: prefixData,
  key: "ID",
});

const groupData = [
  { ID: 0, Text: "No" },
  { ID: 1, Text: "Begin" },
  { ID: 2, Text: "End" },
];

const groupDataSource = new ArrayStore({
  data: groupData,
  key: "ID",
});

const operationData = [
  { ID: 0, Text: "StartsWith" },
  { ID: 1, Text: "EndsWith" },
  { ID: 2, Text: "Contains" },
  { ID: 3, Text: "Equal" },
  { ID: 4, Text: "NotEqual" },
  { ID: 5, Text: "Greater" },
  { ID: 6, Text: "GreaterEqual" },
  { ID: 7, Text: "Less" },
  { ID: 9, Text: "LessEqual" },
  { ID: 10, Text: "Between" },
  { ID: 11, Text: "Includes" },
];

const fileFormats = ["PDF", "XLS", "XLSX", "CSV"];

const operationDataSource = new ArrayStore({
  data: operationData,
  key: "ID",
});

let accessToken = "";
let ignoreListSelectionChange = false;
let ignoreMacroSelectionChange = false;

class ABRReport extends React.Component {
  constructor(props) {
    super(props);

    accessToken = props.oidc.user.access_token;
    
    this.state = {
      animationDuration: 300,
      selectedItems: searchpanel,
      loadIndicatorVisible: false,
      isGetReportPopupVisible: false,
      isReportInProgressPopupVisible: false,
      isLookUpFormPopupVisible: false,
      colName: "",
      popupname: "",
      gridrowindex: '',
      connection: null,
      searchPanelStatus: true,
      opened: (props.oidc.user.profile.hasOwnProperty("LOGINTYPEID") && props.oidc.user.profile.LOGINTYPEID == ABECASUSER_LOGIN_TYPE),
      generatedFileName: "",
      report: {
        name: "",
        fullName: "",
        formatName: "",
        macroName: "",
        fileFormat: "PDF",
        parameterList: [],
        queryParameters: [],
        whereInfoList: [],
        filterWhereInfoList: [
          /* {default:false,
          displayLabel : "Activity",
          fieldName: "ACTIVITY",
          fieldType: 0,
          from : null,
          group : 0,
          include : 0,
          items: null,
          lookupName : null,
          operation : 0,
          orderBy : 0,
          origin :  "CAACTIVITY.ACTIVITY",
          persistent : false,
          position : 0,
          prefix : 0,
          to : null,
          visible : true} */
        ],
      },
    };

    const newConnection = new HubConnectionBuilder()
      .withUrl(`${window._env_.REACT_APP_APIS.substring(0, window._env_.REACT_APP_APIS.length - 4)}/hubs/report`)
      .withAutomaticReconnect()
      .build();

    this.state.connection = newConnection;

    if (this.state.connection) {
      this.state.connection
        .start()
        .then((result) => {
          console.log("Connected!");

          this.state.connection.on("ReceiveMessage", (message) => {
            this.setState({
              generatedFileName: message.message,
              isGetReportPopupVisible: true,
              isReportInProgressPopupVisible: false,
            });
          });
        })
        .catch((e) => console.log("Connection failed: ", e));
    }

    this.dataFieldSelectionChanged = this.dataFieldSelectionChanged.bind(this);
    this.dataFieldRender = this.dataFieldRender.bind(this);
    this.previewButtonClicked = this.previewButtonClicked.bind(this);
    this.resetButtonClicked = this.resetButtonClicked.bind(this);
    this.handleReportFormatChanged = this.handleReportFormatChanged.bind(this);
    this.handleReportMacroChanged = this.handleReportMacroChanged.bind(this);
    this.fileFormatChanged = this.fileFormatChanged.bind(this);
    this.loadReport = this.loadReport.bind(this);
    this.editorPreparing = this.editorPreparing.bind(this);
    this.searchPopupCellRender = this.searchPopupCellRender.bind(this);
    this.openSearchPopup = this.openSearchPopup.bind(this);
    this.handleClosePopUpCallback = this.handleClosePopUpCallback.bind(this);
    this.handleCallbackforReportLookUp = this.handleCallbackforReportLookUp.bind(this);
    this.CellClik = this.CellClik.bind(this);
    this.isValidDate = this.isValidDate.bind(this);
    this.selectionChanged = this.selectionChanged.bind(this);
    this.toolbarItems = [{
      widget: 'dxButton',
      location: 'right',
      options: {
        icon: 'menu',
        onClick: () => this.setState({ opened: !this.state.opened }),
      },
    }];
    this.loadReport();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.Name !== this.props.Name
        || prevProps.FormatName !== this.props.FormatName
        || prevProps.match?.params?.id !== this.props.match?.params?.id) {
      this.loadReport();
    }
  }

  // The ART format name to load. AT mode (Name set) uses the base report; otherwise
  // it comes from the FormatName prop (generic /reports/run route) or, when opened
  // via the /at/artreport/:id route, the URL segment.
  formatNameForLoad() {
    if (this.props.Name !== undefined) return "";
    if (this.props.FormatName !== undefined && this.props.FormatName !== null) return this.props.FormatName;
    return (this.props.match && this.props.match.params) ? this.props.match.params.id : "";
  }
  selectionChanged(e) {
    let newItems = [...this.state.selectedItems];
    e.removedItems.forEach((item) => {
      const index = newItems.indexOf(item);
      if (index >= 0) {
        newItems.splice(index, 1);
      }
    });
    if (e.addedItems.length) {
      newItems = [...newItems, ...e.addedItems];
    }
    this.setState({
      selectedItems: newItems
    });
    this.setState(prevState => ({
      searchPanelStatus: !prevState.searchPanelStatus
  }));
  }
  download = () => {
    var url = `${window._env_.REACT_APP_APIS}/${routes.reports.GetReportFile}?fileName=${this.state.generatedFileName}`;

    const link = document.createElement("a");
    link.href = url;
    link.download = this.state.generatedFileName;
    link.click();
  };

  handleCallbackforReportLookUp(data) {
    if (this.state.gridrowindex && (this.state.colName == "to" || this.state.colName == "from")) {
      if (dataGrid.current && typeof dataGrid.current.instance === 'function') {
        const instance = dataGrid.current.instance();
        if (instance && typeof instance.cellValue === 'function') {
          instance.cellValue(this.state.gridrowindex, this.state.colName, data);
        }
      }
    }
    this.setState({
      gridrowindex: '',
      isLookUpFormPopupVisible: false
    });
  };

  openSearchPopup(e) {
    let rowIndex = e.element.attributes['data-rowindex'].value;
    let lkupnm = e.element.attributes['data-lookupName'].value;
    this.setState({
      isLookUpFormPopupVisible: true,
      popupname: lkupnm,
      gridrowindex: rowIndex
    });
  };

  handleClosePopUpCallback() {
    this.setState({
      isLookUpFormPopupVisible: false,
    });
  };

  searchPopupCellRender(rowobj) {

    if (rowobj && rowobj.data && rowobj.data.popupName &&
      ((rowobj.data.popupName.toLowerCase() == "wmitem") || (rowobj.data.popupName.toLowerCase() == "wmlot") ||
        (rowobj.data.popupName.toLowerCase() == "wmsublot") || (rowobj.data.popupName.toLowerCase() == "location"))) {

      let lkupnm = (rowobj.data.popupName.toLowerCase() == "wmitem") ? "Item" : (rowobj.data.popupName.toLowerCase() == "wmlot") ? "Lot" :
        (rowobj.data.popupName.toLowerCase() == "wmsublot") ? "SubLot" : (rowobj.data.popupName.toLowerCase() == "location") ? "Location" : "";

      let buttonAttributes = { 'data-rowIndex': rowobj.rowIndex.toString(), 'data-lookupName': lkupnm }
      return <Button icon="find" onClick={this.openSearchPopup} elementAttr={buttonAttributes} />;

    }
    else
      return "";

  };

  CellClik(e) {
    if (e.column && (e.column.caption.toLowerCase() == 'to' || e.column.caption.toLowerCase() == 'from')) {
      this.setState({
        colName: e.column.caption.toLowerCase(),
      });
    }
  };

  renderPopup = () => {
    return (
      <div>
        <h6 style={{ color: "#76b4ea" }}>Generate Report</h6>
        <p>Report has been generated Successfully Click View Report To See!.</p>
        <Button onClick={this.closeGetReportPopup} className="report-btn">
          Close
        </Button>
        <Button onClick={this.download} className="report-btn ml-3">
          Download Report
        </Button>
      </div>
    );
  };

  renderReportInProgressPopup = () => {
    return (
      <div>
        <h6 style={{ color: "#76b4ea" }}>Generate Report</h6>
        <p>Report generation is in progess ...</p>
        <Button
          onClick={this.closeReportInProgressPopup}
          className="report-btn"
        >
          Close
        </Button>
      </div>
    );
  };

  closeGetReportPopup = () => {
    this.setState({
      isGetReportPopupVisible: false,
      isReportInProgressPopupVisible: false,
    });
  };

  closeReportInProgressPopup = () => {
    this.setState({
      isReportInProgressPopupVisible: false,
    });
  };

  render() {
    return (
      <div className="search-page-container">
        <div className="search-page-content">
          <div id="accordion" className="search-page-accordion">
              <Accordion
                dataSource={searchpanel}
                collapsible={true}
                multiple={false}
                animationDuration={this.state.animationDuration}
                selectedItems={this.state.selectedItems}
                onSelectionChanged={this.selectionChanged}
                itemTitleRender={() => (
                  <Toolbar className="accordian-toolbar">
                    <Item location="before">
                      <div className="title">
                        <h6
                          style={{
                            color: window._env_.Color2
                          }}
                        >
                          {this.props.Title}
                        </h6>
                      </div>
                    </Item>
                    <Item location="after">
                      <RadioGroup
                        style={{ marginRight: "10px" }}
                        items={fileFormats}
                        value={this.state.report.fileFormat}
                        layout="horizontal"
                        onValueChanged={this.fileFormatChanged}
                      />
                    </Item>
                    <Item location="after">
                      <Button className="accordianButton" onClick={this.previewButtonClicked} type="default">
                        <LoadIndicator
                          style={{
                            height: "20px",
                            width: "20px",
                            verticalAlign: "middle",
                            marginRight: "5px",
                          }}
                          visible={this.state.loadIndicatorVisible}
                        />
                        <span className="dx-button-text">Preview</span>
                      </Button>
                    </Item>
                    <Item location="after" >
                      <Button className="accordianButton"
                        text="Reset"
                        onClick={this.resetButtonClicked}
                      />
                    </Item>
                  </Toolbar>
                )}
                itemRender={(itemProps) => (
                  <div>
                    {this.props.Name !== undefined ?
                      <div className="row">
                        <div className="col-md-3 " style={{ paddingRight: '0px' }}>
                          <SelectBox
                            ref={selectBox}
                            placeholder="Select a Format"
                            onValueChanged={this.handleReportFormatChanged}
                            defaultValue={this.state.report.formatName}
                            stylingMode='outlined' labelMode="static"
                            label="Format"
                          />
                        </div>
                        <div className="col-md-3 " style={{ marginLeft: '5px' }}>
                          <SelectBox
                            ref={selectBoxMacro1}
                            placeholder="Select a Macro"
                            onValueChanged={this.handleReportMacroChanged}
                            defaultValue={this.state.report.macroName}
                            stylingMode='outlined' labelMode="static"
                            label="Macro"
                          />
                        </div>
                      </div>
                      : <div className="row">

                        <div className="col-md-3 " style={{ paddingRight: '0px' }}>
                          <SelectBox
                            ref={selectBoxMacro2}
                            placeholder="Select a Macro"
                            onValueChanged={this.handleReportMacroChanged}
                            defaultValue={this.state.report.macroName}
                            stylingMode='outlined' labelMode="static"
                            label="Macro"
                          />
                        </div>
                      </div>}
                    <div className="row accordianLastRow" style={{ width: '98.6%' }}>
                      <div className="col-md-12">
                        <Form
                          id="form"
                          labelMode="static"
                          labelLocation="left"
                          stylingMode='outlined'
                          formData={this.state.formData}
                          items={this.state.formItems}
                          colCount={4}
                        />
                      </div>
                    </div>

                  </div>


                )}
                id="accordion-container" className="accordion-height"
              />
          </div>
          <div className="row" style={{ flex: '0 0 auto' }}>
            <div className={this.state.opened ? 'toolbar-holder' : 'toolbar-holder collapse-drawer '}>
              <Toolbar >
                <Item location="before">
                  <Button icon='menu' className="gridTopButton" onClick={() => this.setState({ opened: !this.state.opened })}  />
                </Item>
              </Toolbar>
            </div>
          </div>
          <div className="search-page-grid-container">
            <Drawer
              opened={this.state.opened}
              openedStateMode={'shrink'}
              position={'left'}
              revealMode={'slide'}
              style={{ 
                flex: '1 1 auto',
                minHeight: 0,
                height: '100%'
              }}
              render={() =>
                <List
                  ref={list}
                  items={this.state.report.whereInfoList}
                  displayExpr="displayLabel"
                  searchEnabled={true}
                  searchExpr="displayLabel"
                  style={{ 
                    backgroundColor: '#f0f1ef',
                    flex: '1 1 auto',
                    minHeight: 0,
                    height: '100%'
                  }}
                  showSelectionControls={true}
                  selectionMode="multiple"
                  onSelectionChanged={this.dataFieldSelectionChanged}
                  onItemRendered={this.dataFieldRender}
                ></List>}
              closeOnOutsideClick={false}>
              <div style={{ 
                flex: '1 1 auto',
                minHeight: 0,
                height: '100%',
                display: 'flex',
                flexDirection: 'column'
              }}>
                <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
                  id="gridContainer"
                  ref={dataGrid}
                  showBorders={true}
                  className="search-page-grid"
                  rowAlternationEnabled={true}
                  allowColumnReordering={true}
                  allowColumnResizing={true}
                  columnAutoWidth={true}
                  onEditorPreparing={this.editorPreparing}
                  onCellClick={this.CellClik}
                >
                  <Editing
                    mode="cell"
                    newRowPosition="last"
                    refreshMode="repaint"
                    allowUpdating={true}
                  />
                  <Column
                    dataField="displayLabel"
                    caption="Display Label"
                    allowEditing={false}
                  />
                  <Column dataField="orderBy" caption="Order By">
                    <Lookup
                      dataSource={orderByDataSource}
                      displayExpr="Text"
                      valueExpr="ID"
                    />
                  </Column>
                  <Column dataField="prefix" caption="Prefix">
                    <Lookup
                      dataSource={prefixDataSource}
                      displayExpr="Text"
                      valueExpr="ID"
                    />
                  </Column>
                  <Column dataField="group" caption="Group">
                    <Lookup
                      dataSource={groupDataSource}
                      displayExpr="Text"
                      valueExpr="ID"
                    />
                  </Column>
                  <Column dataField="operation" caption="Operation">
                    <Lookup
                      dataSource={operationDataSource}
                      displayExpr="Text"
                      valueExpr="ID"
                    />
                  </Column>
                  <Column dataField="From" caption="From" />
                  <Column dataField="To" caption="To" />
                  <Column caption="" allowEditing={false} cellRender={this.searchPopupCellRender} />
                </DataGrid>
              </div>
            </Drawer>
          </div>
        </div>
        <Popup
          width={450}
          height={160}
          showTitle={false}
          title="Generate Report!"
          dragEnabled={false}
          hideOnOutsideClick={true}
          visible={this.state.isGetReportPopupVisible}
          contentRender={this.renderPopup}
        />
        <Popup
          width={450}
          height={160}
          showTitle={false}
          title="Generate Report!"
          dragEnabled={false}
          hideOnOutsideClick={true}
          visible={this.state.isReportInProgressPopupVisible}
          contentRender={this.renderReportInProgressPopup}
        />
        {this.state.isLookUpFormPopupVisible &&
          <Popup
            visible={this.state.isLookUpFormPopupVisible}
            onHiding={this.handleClosePopUpCallback}
            dragEnabled={false}
            hideOnOutsideClick={true}
            showCloseButton={true}
            showTitle={true}
            title={this.state.popupname + " Look Up Form"}
            container=".dx-viewport"
            closeOnOutsideClick={true}
          >
            <ScrollView width="100%" height="100%">
              <LookUpForm lookupname={this.state.popupname} parentCallbackLookUp={this.handleCallbackforReportLookUp}
              ></LookUpForm>
            </ScrollView>
          </Popup>
        }
      </div>
    );
  }

  loadReport() {
    var that = this;
    axios
      .get(
        `${window._env_.REACT_APP_APIS}/${routes.reports.GetArtReport}?reportName=ABR0001&formatName=${this.formatNameForLoad()}`,
        {
          headers: {
            "Content-Type": "application/json",
            access_token: accessToken,
            Authorization: `Bearer ${accessToken}`
          },
        }
      )
      .then((res) => {
        that.setState({
          report: res.data,
        });

        var dataFilterDataSource = new ArrayStore({
          data: that.state.report.filterWhereInfoList,
          key: "displayLabel",
        });

        if (dataGrid.current && typeof dataGrid.current.instance === 'function') {
          const instance = dataGrid.current.instance();
          if (instance && typeof instance.option === 'function') {
            instance.option("dataSource", dataFilterDataSource);
          }
        }

        if (that.props.Name !== undefined) {
          axios
            .get(
              `${window._env_.REACT_APP_APIS}/${routes.reports.GetReportFormatsForABR}`,
              {
                headers: {
                  "Content-Type": "application/json",
                  access_token: accessToken,
                  Authorization: `Bearer ${accessToken}`,
                },
              }
            )
            .then((res) => {
              var reportFormatDataSource = new ArrayStore({
                data: res.data,
              });

              if (selectBox.current && typeof selectBox.current.instance === 'function') {
                const instance = selectBox.current.instance();
                if (instance && typeof instance.option === 'function') {
                  instance.option(
                    "dataSource",
                    reportFormatDataSource
                  );
                  instance.option(
                    "value",
                    that.state.report.formatName
                  );
                }
              }
            })
            .catch((err) => {
              console.log(err, "Error getting report format data");
            });
        }

        axios
          .get(
            `${window._env_.REACT_APP_APIS}/${routes.reports.GetReportMacros}?reportName=ABR0001&formatName=${this.formatNameForLoad()}`,
            {
              headers: {
                "Content-Type": "application/json",
                access_token: accessToken,
                Authorization: `Bearer ${accessToken}`,
              },
            }
          )
          .then((res) => {
            var reportMacroDataSource = new ArrayStore({
              data: res.data,
            });

            var selectBoxMacro = that.props.Name !== undefined ? selectBoxMacro1 : selectBoxMacro2;

            if (selectBoxMacro && selectBoxMacro.current && typeof selectBoxMacro.current.instance === 'function') {
              const instance = selectBoxMacro.current.instance();
              if (instance && typeof instance.option === 'function') {
                instance.option(
                  "dataSource",
                  reportMacroDataSource
                );

                ignoreMacroSelectionChange = true;
                instance.option(
                  "value",
                  that.state.report.macroName
                );
                ignoreMacroSelectionChange = false;
              }
            }

          })
          .catch((err) => {
            console.log(err, "Error getting report macro data");
          });

      })
      .catch((err) => {
        console.log(err, "Error getting report data");
      });
  }

  fileFormatChanged(e) {
    if(e?.event)
      e.event.stopPropagation();
    var report = { ...this.state.report };
    report.fileFormat = e.value;
    this.setState({ report });
  }

  handleReportFormatChanged(e) {
    var report = { ...this.state.report };
    report.formatName = e.value;
    this.setState({ report });
    var that = this;

    axios
      .get(
        `${window._env_.REACT_APP_APIS}/${routes.reports.GetArtReport}?reportName=${this.props.Name}&formatName=${report.formatName}`,
        {
          headers: {
            "Content-Type": "application/json",
            access_token: accessToken,
          },
        }
      )
      .then((result) => {
        report = { ...that.state.report };
        report.macroName = "";
        if (result.data) {
          report.whereInfoList = result.data.whereInfoList;
        }
        else {
          report.whereInfoList = [];
        }

        report.filterWhereInfoList = [];

        that.setState({ report });
        var dataFilterDataSource = new ArrayStore({
          data: that.state.report.filterWhereInfoList,
          key: "displayLabel",
        });

        if (dataGrid.current && typeof dataGrid.current.instance === 'function') {
          const instance = dataGrid.current.instance();
          if (instance && typeof instance.option === 'function') {
            instance.option("dataSource", dataFilterDataSource);
          }
        }
      });

    axios
      .get(
        `${window._env_.REACT_APP_APIS}/${routes.reports.GetReportMacros}?reportName=${this.props.Name}&formatName=${report.formatName}`,
        {
          headers: {
            "Content-Type": "application/json",
            access_token: accessToken,
            Authorization: `Bearer ${accessToken}`,
          },
        }
      )
      .then((res) => {
        var reportMacroDataSource = new ArrayStore({
          data: res.data,
        });

        var selectBoxMacro = that.props.Name !== undefined ? selectBoxMacro1 : selectBoxMacro2;

        if (selectBoxMacro && selectBoxMacro.current && typeof selectBoxMacro.current.instance === 'function') {
          const instance = selectBoxMacro.current.instance();
          if (instance && typeof instance.option === 'function') {
            instance.option(
              "dataSource",
              reportMacroDataSource
            );
          }
        }

      })
      .catch((err) => {
        console.log(err, "Error getting report macro data");
      });
  }

  handleReportMacroChanged(e) {

    if (!ignoreMacroSelectionChange) {
      var report = { ...this.state.report };
      report.macroName = e.value;
      this.setState({ report });
      var that = this;

      axios.get
        (
          `${window._env_.REACT_APP_APIS}/${routes.reports.GetReportDataByMacro}?macro=${report.macroName}&reportName=ABR0001`,
          {
            headers: {
              "Content-Type": "application/json",
              access_token: accessToken,
            }
          }
        )
        .then((result) => {
          if (result.data) {

            var formData = new Object();
            for (
              var i = 0;
              result.data.parameterList != null &&
              i < result.data.parameterList.length;
              i++
            ) {
              formData[result.data.parameterList[i].name] =
                result.data.parameterList[i].value;
            }

            that.setState({
              formData: formData,
            });

            var dataFilterDataSource = new ArrayStore({
              data: result.data.filterWhereInfoList,
              key: "displayLabel",
            });

            if (dataGrid.current && typeof dataGrid.current.instance === 'function') {
              const instance = dataGrid.current.instance();
              if (instance && typeof instance.option === 'function') {
                instance.option("dataSource", dataFilterDataSource);
              }
            }

            ignoreListSelectionChange = true;
            if (list.current && typeof list.current.instance === 'function') {
              const listInstance = list.current.instance();
              if (listInstance) {
                for (var i = 0; report.whereInfoList != null && i < report.whereInfoList.length; i++) {
                  for (var j = 0; result.data.filterWhereInfoList != null && j < result.data.filterWhereInfoList.length; j++) {
                    if (report.whereInfoList[i].origin == result.data.filterWhereInfoList[j].origin) {
                      if (typeof listInstance.isItemSelected === 'function' && !listInstance.isItemSelected(i)) {
                        if (typeof listInstance.selectItem === 'function') {
                          listInstance.selectItem(i);
                        }
                      }
                      break;
                    }
                  }
                }
              }
            }
            ignoreListSelectionChange = false;
          }

        });
    }
  }

  resetButtonClicked(e) {
    if(e?.event)
      e.event.stopPropagation();
    this.loadReport();
  }

  previewButtonClicked(e) {
    if(e?.event)
      e.event.stopPropagation();
    if (!dataGrid.current || typeof dataGrid.current.instance !== 'function') {
      console.error('DataGrid ref is not available');
      return;
    }
    const instance = dataGrid.current.instance();
    if (!instance || typeof instance.saveEditData !== 'function') {
      console.error('DataGrid instance is not available');
      return;
    }
    instance.saveEditData().then(() => {

      this.setState({
        loadIndicatorVisible: true
      });

      axios
        .post(
          `${window._env_.REACT_APP_APIS}/${routes.reports.GenerateReport}`,
          this.state.report,
          {
            headers: {
              "Content-Type": "application/json",
              access_token: accessToken,
            },
          }
        )
        .then((res) => {
          this.setState({
            loadIndicatorVisible: false
          });

          if (window._env_.Generate_Report_From_Remote) {
            if (res.data.isSuccess) {
              this.setState({
                isGetReportPopupVisible: false,
                isReportInProgressPopupVisible: true,
              });
            } else {
              alert(
                "Cannot generate report. Error:  " + res.data.errorMessage,
                "Error"
              );
            }
          } else {
            if (
              res.hasOwnProperty("data") &&
              res.data != null &&
              res.data != undefined
            ) {
              if (res.data.isSuccess) {
                window.open(
                  `${window._env_.REACT_APP_APIS}/${routes.reports.GetReportFile}?fileName=${res.data.fileName}`,
                  "_blank"
                );
              } else {
                alert(
                  "Cannot generate report. Error:  " + res.data.errorMessage,
                  "Error"
                );
              }
            } else {
              alert("Cannot generate report", "Error");
            }
          }
        })
        .catch((err) => {
          this.setState({
            loadIndicatorVisible: false
          });

          alert(err, "Error");
        });
    });
  }

  isValidDate(date) {
    return date && !isNaN(Date.parse(date));
  }

  editorPreparing(e) {
    if (e.parentType === "dataRow" && e.hasOwnProperty('row') && e.hasOwnProperty('dataField') && e.hasOwnProperty('editorName') &&
      (e.dataField === "from" || e.dataField === "to") && e.editorName == "dxTextBox") {
      if (e.row.data.lookupName == null || e.row.data.lookupName == "") {
        switch (e.row.data.fieldType) {
          case 1: // Integer
          case 2: // Decimal
            e.editorName = "dxNumberBox";
            break;
          case 3: // Boolean
            e.editorName = "dxCheckBox";
            break;
          case 4: // DateTime
            e.editorName = "dxDateBox";
            // const defaultValueChangeHandler = e.editorOptions.onValueChanged;
            var that = this;
            e.editorOptions.onValueChanged = function (args) {  // Override the default handler
              if (that.isValidDate(args.value)) {
                let dt = new Date(args.value);
                e.setValue((dt.getMonth() + 1) + '/' + dt.getDate() + '/' + dt.getFullYear());
                // e.setValue(((dt.getMonth() > 8) ? (dt.getMonth() + 1) : ('0' + (dt.getMonth() + 1))) + '/' + ((dt.getDate() > 9) ? dt.getDate() : ('0' + dt.getDate())) + '/' + dt.getFullYear());
              }
              else {
                e.setValue(args.value);
              }

              // If you want to modify the editor value, call the setValue function:
              // e.setValue(newValue);
              // Otherwise, call the default handler:
              //  defaultValueChangeHandler(args);
            }
            break;
          case 5: // Flag
            e.editorName = "dxSelectBox";
            e.editorOptions.items = [];

            for (var i = 0; i < e.row.data.items.length; i++) {
              var selectBoxItem = new Object();
              selectBoxItem.Value = e.row.data.items[i].text;
              selectBoxItem.Text = e.row.data.items[i].text;
              e.editorOptions.items.push(selectBoxItem);
            }

            e.editorOptions.displayExpr = "Text";
            e.editorOptions.valueExpr = "Text";
            e.editorOptions.showClearButton = true;
            break;
        }
      }
      else {
        e.editorName = "dxSelectBox";
        var selectstore = createStore({
          loadUrl: `${window._env_.REACT_APP_APIS}/${routes.reports.GetLookupData}`,
          loadParams: { lookupName: e.row.data.lookupName },
          onBeforeSend: function (method, ajaxOptions) {
            ajaxOptions.headers = {
              access_token: accessToken,
              Authorization: `Bearer ${accessToken}`
            };
          }

        });
        e.editorOptions.dataSource = selectstore;
        e.editorOptions.searchEnabled = true;
        e.editorOptions.showClearButton = true;
        e.editorOptions.acceptCustomValue = true;
        // e.editorOptions.defaultValue = e.row.data.from;
      }
    }

    if (e.dataField === 'operation' && e.parentType === 'dataRow') {
      const defaultValueChangeHandler = e.editorOptions.onValueChanged;
      e.editorOptions.onValueChanged = function (args) { // Override the default handler
        defaultValueChangeHandler(args);
        if (args.value != 9) {
          e.component.cellValue(e.row.rowIndex, "to", "");
        }

      }
    }

    if (e.dataField === "to" && e.parentType === "dataRow") {
      e.editorOptions.disabled = e.row.data && e.row.data.operation !== 9;
    }
  }

  dataFieldSelectionChanged(e) {
    if (!ignoreListSelectionChange) {
      if (e.addedItems != null && e.addedItems.length === 1) {
        if (dataGrid.current && typeof dataGrid.current.instance === 'function') {
          const instance = dataGrid.current.instance();
          if (instance && typeof instance.getDataSource === 'function') {
            var dataSource = instance.getDataSource();
            if (dataSource && dataSource.store) {
              dataSource
                .store()
                .insert(e.addedItems[0])
                .done(function (dataObj, key) {
                  dataSource.reload();
                })
                .fail(function (error) {
                  alert(error);
                });
            }
          }
        }
      }

      if (e.removedItems != null && e.removedItems.length === 1) {
        if (dataGrid.current && typeof dataGrid.current.instance === 'function') {
          const instance = dataGrid.current.instance();
          if (instance && typeof instance.getDataSource === 'function') {
            var dataSource = instance.getDataSource();
            if (dataSource && dataSource.store) {
              dataSource
                .store()
                .remove(e.removedItems[0].displayLabel)
                .done(function (dataObj, key) {
                  dataSource.reload();
                })
                .fail(function (error) {
                  alert(error);
                });
            }
          }
        }
      }
    }
  }

  dataFieldRender(e) {
    if (dataGrid.current && typeof dataGrid.current.instance === 'function') {
      const instance = dataGrid.current.instance();
      if (instance && typeof instance.getDataSource === 'function') {
        var dataSource = instance.getDataSource();
        if (dataSource != null && dataSource._items != null) {
          var found = dataSource._items.find(i => i.origin == e.itemData.origin);
          if (found != null && found != undefined) {
            if (!e.component.isItemSelected(e.itemIndex)) {
              ignoreListSelectionChange = true;
              e.component.selectItem(e.itemIndex);
              ignoreListSelectionChange = false;
            }
          }
        }
      }
    }
  }

}

function mapStateToProps(state) {
  return {
    ReceiptReducer: state.ReceiptReducer,
    oidc: state.oidc,
  };
}

export default connect(mapStateToProps)(ABRReport);
